import { Virtuoso } from 'react-virtuoso';
import { TBuildingStreetWrapper } from 'api/hooks/use-building-search';
import { StreetWrapper } from './StreetWrapper';
import Loader from '../loader';
import NotFound from '../not-found';
import styles from './styles.module.scss';

interface StreetsTabProps {
  buildings: TBuildingStreetWrapper[];
  isLoading: boolean;
  selectedIds: number[];
  setSelectedIds: (ids: number[]) => void;
}

export const StreetsTab: React.FC<StreetsTabProps> = (props: StreetsTabProps) => {
  const { buildings, isLoading, selectedIds, setSelectedIds } = props;

  if (isLoading) return <Loader />;
  if (!isLoading && !buildings.length) return <NotFound />;
  return (
    <div className={styles.tabContainerList}>
      <Virtuoso
        useWindowScroll
        data={buildings}
        style={{ height: '100%' }}
        itemContent={(idx, i) => {
          return (
            <StreetWrapper
              i={i}
              idx={idx}
              key={i.streetName}
              selectedIds={selectedIds}
              setSelectedIds={setSelectedIds}
            />
          );
        }}
      />
    </div>
  );
};
